/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_DescriptionInputs */

const en_contact_description = /** @type {(inputs: Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get in touch with the PureJSON team. Questions, bug reports, and feature ideas are all welcome.`)
};

const ko_contact_description = /** @type {(inputs: Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON 팀에 연락하세요. 질문, 버그 제보, 기능 제안 모두 환영합니다.`)
};

const ja_contact_description = /** @type {(inputs: Contact_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PureJSON チームにご連絡ください。ご質問、バグ報告、機能のご提案を歓迎します。`)
};

/**
* | output |
* | --- |
* | "Get in touch with the PureJSON team. Questions, bug reports, and feature ideas are all welcome." |
*
* @param {Contact_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const contact_description = /** @type {((inputs?: Contact_DescriptionInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_DescriptionInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_description(inputs)
	if (locale === "ko") return ko_contact_description(inputs)
	return ja_contact_description(inputs)
});